export default `
fragment FollowedListFragment on followed_lists {
  userId: user_id
  listId: list_id
}
`;
